export default {
  list: {
    colName: "Name",
    colContact: "Kontakt",
    colBalance: "Saldo",
    colActions: "Aktionen",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    retry: "Erneut versuchen",
    emptySearch: "Keine Ergebnisse entsprechen Ihrer Suche.",
    filterRole: "Rolle",
    filterRoleAll: "Alle",
    filterRoleSeller: "Verkäufer",
    filterRoleHost: "Gastgeber",
    filterRoleSalesAgent: "Vertriebsagenten",
    filterRoleAdmin: "Staff",
    statusTooltipActive: "Aktives Konto",
    statusTooltipInactive: "Deaktiviertes Konto",
    filterStatus: "Status",
    filterAll: "Alle",
    filterActive: "Aktiv",
    filterInactive: "Inaktiv",
    openRowAria: "Benutzer {{name}} öffnen",
    relevantSeller_one: "{{count}} Aktivität",
    relevantSeller_other: "{{count}} Aktivitäten",
    relevantHost_one: "{{count}} Struktur",
    relevantHost_other: "{{count}} Strukturen",
    relevantSalesAgent_one: "{{count}} Zuordnung",
    relevantSalesAgent_other: "{{count}} Zuordnungen",
  },
  detail: {
    backToUsers: "Zurück zu Benutzern",
    activate: "Aktivieren",
    deactivate: "Deaktivieren",
    statWallet: "Wallet-Saldo",
    statRevenue: "Gesamtumsatz",
    contactCard: "Kontaktinformationen",
    email: "Konto-E-Mail",
    phone: "Telefon",
    contactEmail: "Kontakt-E-Mail",
    vatNumber: "USt-IdNr.",
    billingAddress: "Rechnungsadresse",
    legalInfoCard: "Rechtliches Profil",
    editLegalInfo: "Profil bearbeiten",
    cancelEditLegalInfo: "Bearbeitung abbrechen",
    loadLegalInfo: "Rechtliches Profil wird geladen...",
    loadLegalInfoError: "Rechtliches Profil konnte nicht geladen werden",
    sendPasswordReset: "E-Mail zum Passwort-Reset senden",
    toastPasswordResetSent: "E-Mail zum Passwort-Reset gesendet.",
    lastLogin: "Letzter Zugriff",
    lastLoginNever: "Nie angemeldet",
    passwordResetActiveLink:
      "Ein Einrichtungslink ist noch bis {when} gültig. Warten Sie, bis er abläuft, bevor Sie einen weiteren senden.",
    passwordResetCooldown:
      "Kürzlich wurde eine Reset-E-Mail gesendet. Sie können nach {when} eine weitere senden.",
    transactionsTitle: "Wallet-Transaktionen",
    tabs: {
      ariaLabel: "Benutzerprofil-Bereiche",
      overview: "Übersicht",
      activities: "Aktivitäten",
      activitiesDesc: "Eigene Angebote",
      structures: "Strukturen",
      structuresDesc: "Häuser & Geräte",
      associations: "Zuordnungen",
      associationsDesc: "Aktivitäts- & Strukturbereich",
      legal: "Rechtlich",
      legalDesc: "Abrechnung, ID & Zahlung",
      transactions: "Transaktionen",
    },
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    editDisplayName: "Anzeigenamen bearbeiten",
    displayNamePlaceholder: "Anzeigename",
    displayNameEmpty: "Anzeigename darf nicht leer sein",
    toastDisplayNameUpdated: "Anzeigename aktualisiert",
    toastDisplayNameError: "Anzeigename konnte nicht aktualisiert werden",
    addActivity: "Aktivität hinzufügen",
    addHouse: "Struktur hinzufügen",
    searchActivitiesPlaceholder: "Aktivitäten suchen…",
    noActivitiesMatchTitle: "Keine passenden Aktivitäten",
    noActivitiesMatchDesc: "Andere Suche oder Statusfilter versuchen.",
    active: "Aktiv",
    inactive: "Inaktiv",
    houseRowCommission: "{{percent}} % Provision",
    moreActions: "Weitere Aktionen",
    shortcutsTitle: "Springen zu",
  },
  createModal: {
    nameLabel: "Name",
    emailLabel: "E-Mail",
    phoneLabel: "Kontakttelefon",
    phonePlaceholder: "+49…",
    phoneRequired: "Kontakttelefon eingeben",
    regionLabel: "Zahlungsregion *",
    chooseRegion: "Region auswählen…",
    regionRequired: "Wählen Sie eine Zahlungsregion",
    inviteEmailHint:
      "Wir senden eine Einladungs-E-Mail, damit die Person ihr Passwort selbst festlegen kann.",
  },
  roles: {
    seller: "Verkäufer",
    host: "Gastgeber",
    "sales-agent": "Vertriebsagent",
    admin: "Staff",
  },
  unified: {
    title: "Benutzer",
    subtitle: "Verkäufer, Gastgeber, Vertriebsagenten und Staff an einem Ort",
    addButton: "Benutzer hinzufügen",
    searchPlaceholder: "Nach Name, E-Mail oder ID suchen...",
    loadError: "Benutzer konnten nicht geladen werden",
    empty: "Noch keine Benutzer",
    colCount: "Anzahl",
  },
  impersonate: "Identität annehmen",
  rolePicker: {
    title: "Welchen Benutzertyp möchten Sie hinzufügen?",
    seller: "Verkäufer",
    host: "Gastgeber",
    salesAgent: "Vertriebsagent",
    staff: "Staff",
    sellerDesc: "Partner mit Attraktionen, Services oder Restaurants",
    hostDesc: "Eigentümer der Unterkünfte, in denen Kioske stehen",
    salesAgentDesc: "Erhält Provisionen für zugewiesene Aktivitäten und Strukturen",
    staffDesc: "Internes Teammitglied mit konfigurierbaren Berechtigungen",
  },
  createStaffModal: {
    title: "Staff-Benutzer hinzufügen",
    namePlaceholder: "Name des Staff-Mitglieds",
    emailPlaceholder: "staff@beispiel.com",
    presetLabel: "Staff-Preset *",
    choosePreset: "Preset auswählen…",
    presetRequired: "Wählen Sie ein Staff-Preset",
    create: "Einladung senden",
    createSuccess: "Staff-Benutzer erstellt — Einladungs-E-Mail gesendet",
    createError: "Staff-Benutzer konnte nicht erstellt werden",
  },
  staffAccess: {
    title: "Rechte für {{name}}",
    subtitle:
      "Weise ein Preset zu, um dessen Live-Rechte zu folgen, oder Benutzerdefiniert für eine individuelle Berechtigungsmenge.",
    loading: "Rechte werden geladen…",
    loadError: "Staff-Rechte konnten nicht geladen werden",
    userNameFallback: "Staff-Benutzer",
    preset: "Staff-Preset",
    presetHint:
      "Preset-gebundene Nutzer übernehmen Änderungen an der Definition automatisch. Rechte ändern wechselt zu Benutzerdefiniert.",
    presetCustom: "Benutzerdefiniert",
    enabledSummary: "{{count}} von {{total}} aktiv",
    permissionsHintPresetBound:
      "Live-Rechte des Presets. Umschalten löst auf Benutzerdefiniert.",
    requiresPermissions: "Aktiviere zuerst diese Rechte:",
    searchPermissions: "Rechte oder Bereiche suchen…",
    searchEmpty: "Keine Rechte passen zur Suche",
    cannotEditSelfTitle: "Deine eigenen Rechte",
    cannotEditSelf:
      "Du kannst deinen eigenen Staff-Zugriff nicht ändern. Bitte einen anderen Super Admin darum.",
    immutableSuperTitle: "Super Admin",
    immutableSuper:
      "Super-Admin-Zugriff lässt sich hier nicht ändern — Beförderung oder Degradierung nur über Ops-Skripte (`set_super_admin.py`).",
    saveSuccess: "Staff-Rechte aktualisiert",
    saveError: "Staff-Rechte konnten nicht aktualisiert werden",
    presets: {
      super_admin: "Super Admin",
      device_tech: "Gerätetechniker",
      data_entry: "Dateneingabe",
      accounting: "Buchhaltung",
      user_management: "Benutzerverwaltung",
    },
    scopes: {
      stats: "Plattformsaldo",
      users: "Benutzer",
      activities: "Aktivitäten",
      houses: "Strukturen",
      storage: "Speicher",
      devices: "Geräte",
      readers: "Lesegeräte",
      bookings: "Buchungen",
      handshakes: "Handshakes",
      customer_support: "Kundensupport",
      partner_support: "Partner-Support",
      payments: "Zahlungen",
      alerts: "Alerts",
      protocols: "Protokolle",
      carousel: "Karussell",
      agent_transcripts: "Sprachtranskripte",
    },
  },
} as const;
